//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { useRightsRequestTCMessage } from '@uia/rights/hooks/useRightsRequestTCMessage';
import { getIsRightsRequestTermsAndConditionsEnabled } from '@uia/rights/selectors/getUIARights';
import { isDefined } from '@utils/filterPredicates';

export const useIsMessageMissingTCMessage = (rightsRequestText?: string) => {
  const isRightsRequestTermsAndConditionsEnabled = useSelector(
    getIsRightsRequestTermsAndConditionsEnabled,
  );

  const rightsRequestTCMessage = useRightsRequestTCMessage({
    rightsRequestText,
  });

  return (
    isRightsRequestTermsAndConditionsEnabled &&
    isDefined(rightsRequestText) &&
    isDefined(rightsRequestTCMessage) &&
    !rightsRequestText.includes(rightsRequestTCMessage)
  );
};
